import componentParser from './component-parser';
import type { ColumnParams, ColumnReturn } from '../types';
export default function (params: ColumnParams): ColumnReturn {
  const {
    cssFlags,
    background,
    components,
    columnSizes,
    minHeight,
    maxWidth,
    padding,
    margin,
    borderRadius,
    badge,
    _uid,
    _editable,
    id
  } = params;

  return {
    module: 'SSectionColumn',
    _uid,
    _editable,
    cssFlags,
    background,
    padding,
    margin,
    badge: {
      ...badge,
      background: badge?.background === '' ? undefined : badge?.background
    },
    id: id === '' ? undefined : id,
    borderRadius: borderRadius === '' ? 'none' : borderRadius,
    maxWidth: maxWidth ? `${maxWidth}px` : 'none',
    minHeight: minHeight ? `${minHeight}px` : 'none',
    columnSizes: Array.isArray(columnSizes)
      ? columnSizes.map((size) => parseInt(size, 10))
      : columnSizes?.split(',')?.map((size) => parseInt(size, 10)),
    components: components?.map((c) => componentParser(c))
  };
}
